import React from 'react';
import { Box, H6, Copy, Link } from '@honda-canada/design-system-react';
import { compiler } from 'markdown-to-jsx';
import { useTranslation } from 'react-i18next';
import themeStyles from './SignupForUpdates.styles';
var ErrorContainer = themeStyles.apply(Box, 'FormSubmissionResultContainer');
var ErrorUI = function () {
    var t = useTranslation().t;
    return (React.createElement(ErrorContainer, { "data-testid": "cy-error-container" },
        React.createElement(H6, { mb: "m", "data-testid": "cy-error-title" }, t('Shared.SignUp.errorHeading')),
        React.createElement(Copy, { size: "regular", mb: "l", "data-testid": "cy-error-description" }, compiler(t('Shared.SignUp.submissionError'), {
            overrides: {
                a: {
                    component: Link,
                    props: {
                        styling: 'redUnderline',
                        fontSize: 'inherit',
                        'data-testid': 'cy-signup-contact-us',
                    },
                },
            },
        }))));
};
export default ErrorUI;
